module.exports = __webpack_public_path__ + "static/img/books3.4ebea287.png";